import * as Color from 'color'

import Button, { baseStyles } from './button'
import { StaticQuery, graphql } from 'gatsby'
import { colors, transition } from '../variables'

import Content from './content'
import Img from 'gatsby-image'
import React from 'react'
import Supertitle from './supertitle'
import Wrapper from './wrapper'
import { css } from '@emotion/core'
import { minWidth } from '../breakpoints'

export default ({ content, author }) => (
  <StaticQuery
    query={graphql`
      query {
        joshua: file(relativePath: { eq: "joshua-author.png" }) {
          childImageSharp {
            fixed(height: 180, width: 180, quality: 80) {
              ...GatsbyImageSharpFixed_tracedSVG
            }
          }
        }
        site: wordpressJoshuaSite {
          authorText
        }
      }
    `}
    render={data => (
      <Wrapper>
        <Content
          styles={{
            marginBottom: 40,
            [minWidth.medium]: {
              marginBottom: 60,
            },
            [minWidth.laptop]: {
              marginBottom: 100,
            },
          }}
        >
          <div
            css={[css`
              .button {
                ${baseStyles}
                transition: background-color ${transition}, color ${transition};

                &.button--blue-dark {
                  background: ${colors.blue60};
                  color: white;

                  &:hover {
                    background: ${colors.orange};
                  }
                }

                &.button--blue-light {
                  background: ${colors.blue80};
                  color: ${colors.blue60};

                  &:hover {
                    background: ${colors.blue60};
                    color: white;
                  }
                }

                &.button--orange {
                  background: ${colors.orange};
                  color: white;

                  &:hover {
                    background: ${colors.blue60};
                  }
                }
              }
            `, {
              marginBottom: 40,
              [minWidth.tablet]: {
                marginBottom: 80,
              },
              '> *': {
                maxWidth: '100%',
              },
              img: {
                boxShadow: `0 10px 50px ${Color(colors.blue60).fade(0.75)}`,
                height: 'auto',
              },
              [minWidth.tablet]: {
                '.alignleft': {
                  float: 'left',
                  margin: '10px 30px 30px 0',
                },
                '.alignright': {
                  float: 'right',
                  margin: '10px 0 30px 30px',
                },
              },
              [minWidth.laptop]: {
                '.alignleft': { margin: '10px 60px 60px 0' },
                '.alignright': { margin: '10px 0 60px 60px' },
              },
              [minWidth.full]: {
                '.alignleft': { marginLeft: -180 },
                '.alignright': { marginRight: -180 },
              },
              '.wp-caption': {
                img: {
                  margin: 0,
                },
                '&.alignleft .wp-caption-text': { marginBottom: 0 },
                '&.alignright .wp-caption-text': { marginBottom: 0 },
              },
              '.wp-caption-text': {
                color: colors.greyBlue,
                fontSize: '0.8rem',
                textAlign: 'center',
              },
              blockquote: {
                fontSize: '1.75rem',
                fontWeight: 800,
                lineHeight: '1.65em',
                marginLeft: 0,
                marginRight: 0,
                [minWidth.tablet]: {
                  fontSize: '2.5rem',
                },
                'p:before': {
                  color: colors.blue60,
                  content: '"“"',
                },
                'p:after': {
                  color: colors.blue60,
                  content: '"”"',
                },
              },
              a: {
                color: colors.blue60,
                ':hover': {
                  color: colors.blue30,
                },
              },
              '> :last-child': {
                margin: 0,
              },
            }]}
            dangerouslySetInnerHTML={{ __html: content }}
          />

          {author && (
            <div css={css`
              clear: left;
              margin-top: 3rem;

              ${minWidth.medium} {
                display: flex;
              }

              ${minWidth.tablet} {
                margin-top: 4rem;
              }
            `}>
              <div
                css={{
                  marginBottom: 20,
                  [minWidth.medium]: {
                    marginBottom: 0,
                    marginRight: 40,
                  },
                  [minWidth.laptop]: {
                    marginRight: 60,
                  },
                }}
              >
                <Img fixed={data.joshua.childImageSharp.fixed} />
              </div>
              <div css={css`
                ${minWidth.medium} {
                  margin-top: 0.5rem;
                }
              `}>
                <Supertitle styles={css`
                  font-size: 0.9em;
                `}>Geschreven door</Supertitle>
                <h2
                  css={{
                    fontSize: '1.5rem',
                    marginBottom: '1.5rem',
                    [minWidth.medium]: {
                      fontSize: '1.77rem',
                    },
                  }}
                >
                  Joshua van Eijndhoven
                </h2>
                <p
                  css={{
                    fontSize: '0.9rem',
                  }}
                >
                  {data.site.authorText}
                </p>
                <Button to="/home/#blog" color="orange">
                  Lees al mijn blogberichten
                </Button>
              </div>
            </div>
          )}
        </Content>
      </Wrapper>
    )}
  />
)
